<template>
<div class="body-main">
  <div class="header">
<!--    <el-button size="mini" @click="editor()">添加</el-button>-->

    <el-input v-model="where2.keyword" style="width: 200px;margin-left: 10px;" size="mini" placeholder="请输入名称" clearable></el-input>

    <el-select v-model="where2.status" class="m-2" filterable placeholder="选择状态" clearable style="margin-left: 10px;" size="mini">
      <el-option
        v-for="item in [{name:'取消合作',value:0},{name:'合作中',value:1}]"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="60vh">
<!--      <el-table-column-->
<!--        prop="id"-->
<!--        label="ID" width="80"></el-table-column>-->
      <el-table-column
        prop="project_name"
        label="项目"
        width="200">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="第三方单位名称" width="240"></el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="company_day"
        label="催费时长（天）"
        width="150">
      </el-table-column>
      <el-table-column
        prop="house_count"
        label="催缴户数"
        width="150" :formatter="intMilFormatter">
      </el-table-column>
      <el-table-column
        prop="house_money"
        label="催缴费用"
        width="150" :formatter="milFormatter">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="100">
        <template slot-scope="scope">
          {{scope.row.status?'合作中':'取消合作'}}
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="created_at"-->
<!--        label="创建时间"-->
<!--        width="100">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="updated_at"
        label="更新时间"
        width="100">
      </el-table-column>
      <el-table-column
        label="	操作"
        min-width="180">
        <template slot-scope="scope">
<!--          <el-button type="primary" size="mini" @click="editor(scope.row)">编辑</el-button>-->
          <el-button type="danger" size="mini" @click="stop(scope.row)">停止合作</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>

  <el-dialog title="详情" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="500px">

    <el-descriptions :column="1" size="mini" border>
      <el-descriptions-item label="单位名称">
        <el-input v-model="formData.name" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="负责人">
        <el-input v-model="formData.head_name" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        <el-input v-model="formData.telephone" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-select v-model="formData.status" class="m-2" filterable placeholder="选择状态" clearable size="mini">
          <el-option
            v-for="item in [{name:'取消合作',value:0},{name:'合作中',value:1}]"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        <el-input v-model="formData.remark" size="mini" clearable></el-input>
      </el-descriptions-item>
    </el-descriptions>

    <template #footer>
      <div style="">
        <el-button size="mini" @click="dialogVisible=false">取消</el-button>
        <el-button size="mini" @click="save">确认</el-button>
      </div>
    </template>
  </el-dialog>
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdPartyCompanyProject",
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      where2:{
        keyword:"",
        status:"",
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      loading: false,
      formData:{
        name:"",
        head_name:"",
        telephone:"",
        status:1,
        remark:""
      },
      dialogVisible:false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)
      where = {
        ...where,
        ...ERP.reJson(that.where),
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        urge_type:that.urge_type,
        // area_id:that.areaId
      }

      ButlerHttp.post("ThirdPartyLegal/getProjectCompanyList", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editor(item=null){
      const that=this;
      if(!item) {
        that.formData={
          name:"",
          head_name:"",
          telephone:"",
          status:1,
          remark:""
        }
      }else {
        that.formData=item;
      }
      that.dialogVisible=true;
    },
    stop(){
      const that = this;
      that.$confirm('停止第三方合作的前提是当前合作商无催缴房产了，确定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = ERP.reJson(that.formData)
        ButlerHttp.post("ThirdPartyLegal/getProjectCompanyStop", {
          id: formData.id
        }, res => {
          if (res.code) {
            that.pageChange(1);
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    save(){
      const that = this;
      that.loading = true;
      let formData = ERP.reJson(that.formData)
      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyEditor", formData, res => {
        if (res.code) {
          that.dialogVisible = false;
          that.pageChange(1);
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },

    deleteItem(item){
      const that=this;

      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyDel", {
        id: item.id
      }, res => {
        if (res.code) {
          that.getList();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    onClose(){

    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "where2.keyword":function (n,o) {
      this.pageChange(1)
    },
    "where2.status":function (n,o) {
      this.pageChange(1)
    },
    "where.thrid_company_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body-main{
  .header{
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }
  .pagination-wrap{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProject.vue